import { toast } from "./toast";
import { toastForApiError } from "../errors";
import type { ApiError } from "../errors";

/**
 * Show the toast mapped to an ApiError: looks up severity + title + description i18n messages
 * via the pure `toastForApiError` mapping, then dispatches to the matching `toast` method. This
 * is the seam callers (query/mutation hooks, later phases) use to surface transport errors.
 */
export function toastApiError(error: ApiError): void {
  const { severity, title, description } = toastForApiError(error);
  toast[severity](title, description);
}
